import { apiPost } from "shared/services/apiRequest";

export const postEssCommand = async (deviceMac, command, value) =>
    (await apiPost("/switches/send-command", { "mac": deviceMac, [command]: value }))?.data;

export const essCommandService = async (deviceMac, data) => {
    await apiPost("/switches/send-command", { "mac": deviceMac, ...data });
}

export const postTgsCommand = async (deviceMac, command, value) =>
    (await apiPost("/blowers/send-command", { "mac": deviceMac, "deviceType": "TGS", [command]: value }))?.data;

export const tgsCommandService = async (deviceMac, data) => {
    await apiPost("/blowers/send-command", { "mac": deviceMac, "deviceType": "TGS", ...data });
}

export const postTesCommand = async (deviceMac, command, value) =>
    (await apiPost("/blowers/send-command", { "mac": deviceMac, "deviceType": "TES", [command]: value }))?.data;

export const tesCommandService = async (deviceMac, data) => {
    await apiPost("/blowers/send-command", { "mac": deviceMac, "deviceType": "TES", ...data });
}
